import { useSelector } from 'react-redux';
import { AccountType } from '@mews-commander/data-access';
import { WithCompanyId, WithScope } from '@mews-commander/types';
import { ContentCard, ResponsiveTwoColumns } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { hasReadOnlyPrivilegesForCompanyData } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import Addresses from '../../../../addresses/containers/Addresses';
import AccountMerge from '../../../../accountMerge/components/AccountMerge';
import { CompanyDetailForms } from '../../../enums';
import { ContactForm } from '../../Forms';
import Files from '../../../../files/components/Files';

type DetailsTabProps = WithCompanyId & WithScope;

const DetailsTab = ({ scope, companyId }: DetailsTabProps) => {
    const readOnlyForm = useSelector(hasReadOnlyPrivilegesForCompanyData);
    const strawberryReadOnlyFields = useFeatureFlag(FeatureFlag.strawberryReadOnlyFieldsEnabled);
    const isReadOnly = readOnlyForm || strawberryReadOnlyFields;
    return (
        <ResponsiveTwoColumns>
            <ContentCard title={<LocalizedText textKey={TextKey.ContactInfo} />}>
                <ContactForm
                    form={`${CompanyDetailForms.ContactForm}-${companyId}`}
                    companyId={companyId}
                    readOnlyForm={isReadOnly}
                />
            </ContentCard>

            <Stack vertical spacing="200">
                <Addresses
                    scope={`company-addresses-${scope}`}
                    // @ts-expect-error $TSFixMeError: Type '{ scope: string; ownerId: string; isCompany: true; noTitleMargin: true; }' is not assignable to type 'IntrinsicAtt...
                    ownerId={companyId}
                    isCompany
                    noTitleMargin
                    readOnlyForm={isReadOnly}
                />
                {/* @ts-expect-error ownerId is required here */}
                <Files scope={`files-${scope}`} readOnlyForm={isReadOnly} ownerId={companyId} noTitleMargin />
                <AccountMerge
                    scope={`company-merge-${scope}`}
                    accountId={companyId}
                    accountType={AccountType.Company}
                    readOnlyForm={isReadOnly}
                />
            </Stack>
        </ResponsiveTwoColumns>
    );
};

export default DetailsTab;
